
// ----------------------------------------------------------------
// HR Module routes
// ----------------------------------------------------------------

const hrRoutes = {

  // Employees routes
  employee: {
    update: "update-employee/",
    list: "employeelist/",
  },

  // Attendance routes
  attendance: {
    checkin: "checkin/",
    checkout: "checkout/",
    checkHoliday: "check-holiday/",
    groupEmployees: "attendance-group/employees",
    groupCheckin: "attendance-group/checkin",
    groupCheckout: "attendance-group/checkout",
  },

  // Salaries routes
  salary: {
    bonus: "bonus/",
    payslipPDF: "salary_print/",
    showPayslipPdfL: "view/",
    bonusdate: "check-bonus-date/"
  },


}

// Export hr routes
export default hrRoutes
